import { Component } from '@angular/core';
import { AbstractFieldReadComponent } from '../base-field/abstract-field-read.component';
import { DocumentStoreService } from '../../../services/document-store/document-store.service';
import { WindowService } from '../../../services/window/window.service';

@Component({
  selector: 'ccd-read-document-field',
  template: require('./read-document-field.html')
})
export class ReadDocumentFieldComponent extends AbstractFieldReadComponent {

  constructor(
      private documentStore: DocumentStoreService,
      private windowService: WindowService) {
    super();
  }

  downloadDocument(docId: string) {
    this.documentStore.downloadUrl(docId)
                      .subscribe(document => {
                        this.windowService.openNewWindow(document.download_url)
                      });
  }
}
